import React from 'react';
import { Box } from '@styleseat/ui';
import { TouchableWithoutFeedback } from 'react-native';
import { BodyText } from '../../../../ui';
import { clickable } from '../../../../../styles';

type NewUnderlineLinkProps = {
  onPress: () => void;
  color: string;
  testID?: string;
};

export const NewUnderlineLink: React.FCWithChildren<NewUnderlineLinkProps> = ({
  onPress,
  color,
  testID,
  children,
}) => (
  <TouchableWithoutFeedback onPress={onPress}>
    <Box alignItems="center" style={clickable}>
      <BodyText
        weight="bold"
        color={color}
        appearance="medium"
        testID={testID}
      >
        {children}
      </BodyText>
      <Box style={{
        backgroundColor: color,
        height: 2,
        bottom: -1.5,
        width: '100%',
      }}
      />
    </Box>
  </TouchableWithoutFeedback>
);
